import styled from 'styled-components'
import { cores } from '../../styles'

export const TagRestaurante = styled.span`
  font-size: 12px;
  padding: 6px 4px;
  color: ${cores.corTexto};
  background-color: ${cores.vermelhoClaro};
`
